<project-item style="width: 100%" *ngFor="let project of projects; let index = index"
              [project]="project"
              [index]="index"
              (projectSelected)="selectProject($event)"
              [selected]="project.uuid == selectedProjectUUId"
              >
</project-item>
